import { FieldMonitoring, FieldMonitoringStatus } from '@indigo-ag/schema';
import i18next from 'core/i18n';
import React, { FunctionComponent } from 'react';

import { FieldMonitoringUtil, UserUtil } from 'shared/utils';
import { NotificationSection } from '../../NotificationSection/NotificationSection';
import { FieldMonitoringMatriculasDetailSummary } from './FieldMonitoringMatriculasDetailSummary';

interface TerraMagnaAnalysisStateProps {
  fieldMonitoringInfo?: FieldMonitoring;
}

const TerraMagnaNotificationStateTitles: { [key in FieldMonitoringStatus]?: string } = {
  [FieldMonitoringStatus.COMPLETED]: i18next.t('completed'),
  [FieldMonitoringStatus.ON_HOLD]: i18next.t('onHold'),
  [FieldMonitoringStatus.IN_PROGRESS]: i18next.t('in_process')
};

export const TerraMagnaAnalysisState: FunctionComponent<TerraMagnaAnalysisStateProps> = ({ fieldMonitoringInfo }) => {
  const getNotificationUpdatedAt = () => {
    return FieldMonitoringUtil.hasBeenSent(fieldMonitoringInfo?.status)
      ? fieldMonitoringInfo?.completedAt
      : FieldMonitoringUtil.hasNotBeenSent(fieldMonitoringInfo?.status)
      ? fieldMonitoringInfo?.startedAt
      : fieldMonitoringInfo?.decisionChangedAt;
  };

  const getNotificationUpdatedBy = () => {
    return FieldMonitoringUtil.hasBeenSent(fieldMonitoringInfo?.status)
      ? UserUtil.getUserFullName(fieldMonitoringInfo?.completedBy)
      : FieldMonitoringUtil.hasNotBeenSent(fieldMonitoringInfo?.status)
      ? UserUtil.getUserFullName(fieldMonitoringInfo?.startedBy)
      : UserUtil.getUserFullName(fieldMonitoringInfo?.decisionChangedBy);
  };

  return (
    <NotificationSection
      title={TerraMagnaNotificationStateTitles[fieldMonitoringInfo?.status || ''] || FieldMonitoringStatus.NOT_STARTED}
      subtitle={fieldMonitoringInfo?.decisionNotes}
      status={fieldMonitoringInfo?.completedAt ? 'success' : 'warning'}
      updateBy={getNotificationUpdatedBy()}
      updatedAt={getNotificationUpdatedAt()}
    >
      {fieldMonitoringInfo?.completedAt ? <FieldMonitoringMatriculasDetailSummary /> : null}
    </NotificationSection>
  );
};
